import axios from 'axios';
import * as _ from 'lodash-es';

const enums = {
  email: 'sähköposti',
  phone: 'puhelimitse',
};

const titles = {
  livingArea: 'Pinta-ala',
  location: 'Sijainti',
  propertyType: 'Kohdetyyppi',
  numberOfRooms: 'Huoneluku',
  contactTime: 'Yhteydenottoaika',
  contactTypes: 'Yhteydenottotapa',
};

const formatMessage = (form: any) => {
  const message = form.message ? `${form.message}\n\n` : '';
  return formatExtraFields(message, form, titles);
};

const formatExtraFields = (message: string, fields: any, titles: any) => {
  _.each(fields, (value, key) => {
    value = `${value}`; // convert to string
    if (value && value.length > 0 && titles[key]) {
      // @ts-ignore - Until types fixed
      const val = Array.isArray(value) ? _.map(value, (v) => enums[v] || v) : enums[value] || value;
      message += `${titles[key]}: ${val}\n`;
    }
  });
  return message;
};

const recaptchaValidation = (action: any) => {
  return new Promise((resolve, reject) => {
    grecaptcha.ready(function () {
      grecaptcha
        .execute('6Lcs9awZAAAAAIg5qOpFkbrTFWfXJZ-bI5TQkXbs', {
          action: action,
        })
        .then(function (token) {
          return axios
            .post('/api/recaptchaValidation', { token, action })
            .then((response) => resolve(response))
            .catch((err) => reject(err));
        });
      // .catch((err) => reject(err));  // Property 'catch' does not exist on type 'Promise<void>'.
    });
  });
};
export default {
  formatMessage,
  formatExtraFields,
  recaptchaValidation,
};
